var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTotalRevenueIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_588_30295)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0938 22.6895C10.0938 16.062 15.4663 10.6895 22.0938 10.6895H33.0938C39.7212 10.6895 45.0938 16.062 45.0938 22.6895V45.6895H22.0937C15.4663 45.6895 10.0938 40.3169 10.0938 33.6895V22.6895Z",
    fill: "url(#paint0_linear_588_30295)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0039 23.0523C18.0039 22.107 18.7711 21.3398 19.7164 21.3398H32.731C33.6763 21.3398 34.4435 22.107 34.4435 23.0523V30.5871C34.4435 31.5324 33.6763 32.2995 32.731 32.2995H19.7164C18.7711 32.2995 18.0039 31.5324 18.0039 30.5871V23.0523ZM22.1138 23.3948V22.7098H20.7438V23.3948C20.7438 23.5765 20.6717 23.7507 20.5432 23.8791C20.4147 24.0076 20.2405 24.0798 20.0588 24.0798H19.3739V25.4497H20.0588C20.6039 25.4497 21.1265 25.2332 21.5119 24.8479C21.8973 24.4625 22.1138 23.9398 22.1138 23.3948ZM28.9636 26.8197C28.9636 26.093 28.6749 25.3961 28.1611 24.8823C27.6473 24.3684 26.9504 24.0798 26.2237 24.0798C25.497 24.0798 24.8001 24.3684 24.2863 24.8823C23.7724 25.3961 23.4838 26.093 23.4838 26.8197C23.4838 27.5464 23.7724 28.2433 24.2863 28.7571C24.8001 29.2709 25.497 29.5596 26.2237 29.5596C26.9504 29.5596 27.6473 29.2709 28.1611 28.7571C28.6749 28.2433 28.9636 27.5464 28.9636 26.8197ZM31.7035 22.7098H30.3336V23.3948C30.3336 23.9398 30.5501 24.4625 30.9354 24.8479C31.3208 25.2332 31.8435 25.4497 32.3885 25.4497H33.0735V24.0798H32.3885C32.2068 24.0798 32.0326 24.0076 31.9042 23.8791C31.7757 23.7507 31.7035 23.5765 31.7035 23.3948V22.7098ZM22.1138 30.2446C22.1138 29.6996 21.8973 29.1769 21.5119 28.7915C21.1265 28.4062 20.6039 28.1897 20.0588 28.1897H19.3739V29.5596H20.0588C20.2405 29.5596 20.4147 29.6318 20.5432 29.7602C20.6717 29.8887 20.7438 30.0629 20.7438 30.2446V30.9296H22.1138V30.2446ZM31.7035 30.9296V30.2446C31.7035 30.0629 31.7757 29.8887 31.9042 29.7602C32.0326 29.6318 32.2068 29.5596 32.3885 29.5596H33.0735V28.1897H32.3885C31.8435 28.1897 31.3208 28.4062 30.9354 28.7915C30.5501 29.1769 30.3336 29.6996 30.3336 30.2446V30.9296H31.7035ZM22.7988 35.0395C22.3648 35.0396 21.9419 34.9024 21.5907 34.6474C21.2395 34.3925 20.9781 34.0329 20.8438 33.6202C21.0343 33.6531 21.2288 33.6695 21.4288 33.6695H32.731C33.5485 33.6695 34.3325 33.3447 34.9106 32.7667C35.4887 32.1886 35.8134 31.4046 35.8134 30.5871V24.1962C36.2142 24.3379 36.5612 24.6005 36.8066 24.9477C37.052 25.2948 37.1836 25.7096 37.1834 26.1347V30.5871C37.1834 31.1718 37.0682 31.7508 36.8445 32.2909C36.6207 32.8311 36.2927 33.322 35.8793 33.7354C35.4659 34.1488 34.975 34.4768 34.4348 34.7005C33.8947 34.9243 33.3157 35.0395 32.731 35.0395H22.7988Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_588_30295",
    x: 0.09375,
    y: 0.689453,
    width: 55,
    height: 55,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.589833 0 0 0 0 0.108333 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "darken",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_588_30295"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_588_30295",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_588_30295",
    x1: 30.0648,
    y1: 45.6895,
    x2: 29.849,
    y2: 10.6895,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB01F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCF45"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalRevenueIcon);
export default __webpack_public_path__ + "static/media/total-revenue-icon.cff35e529c373a918b3e7b1a1ee6e31e.svg";
export { ForwardRef as ReactComponent };